import { useEffect } from "react";
import MobileProjectMenu from "./MobileProjectMenu";
function MobileProject({
  role,
  title,
  billing,
  imageSrc,
  nextImage,
  prevImage,
  setCurrentIndex,
  nextProject,
  prevProject,
  projectKey,
  setCurrentProject,
}) {
  // Keep currentProject in sync with the route actually being viewed,
  // so image-cycling math always uses this project's image array length.
  useEffect(() => {
    if (projectKey && setCurrentProject) {
      setCurrentProject(projectKey);
    }
  }, [projectKey, setCurrentProject]);

  return (
    <div className="project">
      <div className="project-image-container">
        <img src={imageSrc} className="project-image" alt={`${title} set`} />
      </div>

      <div className="project-body">
        <h1 className="project-text" id="project-role">
          {role}
        </h1>
        <h1 className="project-text" id="project-title">
          {title}
        </h1>
        <h1 className="project-text" id="project-billing">
          {billing}
        </h1>
      </div>
      
      <MobileProjectMenu
        nextImage={nextImage}
        prevImage={prevImage}
        nextProject={nextProject}
        prevProject={prevProject}
        setCurrentIndex={setCurrentIndex}
      />
    </div>
  );
}

export default MobileProject;
